import React from 'react';
import icon1 from '../../assests/images/computer.png'
import icon2 from '../../assests/images/learn.png'
import icon3 from '../../assests/images/tictactow.png'
import {FaGithub} from 'react-icons/fa'
import {ServiceH4} from './ServicesElements'
 import {ServicesContainer,ServicesH1,ServicesWrapper
,ServicesIcon,ServicesCard,ServicesH2,ServicesP,ServiceLink,FaGithub as Git,ServiceH1} from './ServicesElements'

const Services = () => {
  return (
    <ServicesContainer id="projects">
      <ServicesH1>My projects</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
        <ServiceLink href='https://eladbarzilay-couponsystem.netlify.app' target='_blank'>
          <ServicesIcon src={icon1}/>
          </ServiceLink>
          <ServicesH2>Coupon system</ServicesH2>
          <ServicesP>coupon managment platform</ServicesP>
          <ServiceH4>Backend: Java with spring Framework</ServiceH4>
          <ServiceH4>Frontend: React.js</ServiceH4>
          <ServiceLink href='https://github.com/eladbarzilay/couponSystemSpring' target='_blank'>
            <ServiceH1>
              <FaGithub/>
            </ServiceH1>
          </ServiceLink>
        </ServicesCard>
        <ServicesCard>
        <ServiceLink href='https://elad-exercise-site.netlify.app/' target='_blank'>
          <ServicesIcon src={icon2}/>
          </ServiceLink>
          <ServicesH2>Learn code</ServicesH2>
          <ServicesP>learning on your own</ServicesP>
          <ServiceH4>Backend: Node.js</ServiceH4>
          <ServiceH4>Frontend: React.js</ServiceH4>
          <ServiceLink href='https://github.com/eladbarzilay/Practice_Programming-main' target='_blank'>
            <ServiceH1>
              <FaGithub/>
            </ServiceH1>
          </ServiceLink>
        </ServicesCard>
        <ServicesCard>
        <ServiceLink href='https://elad-tic-tac-toe.netlify.app/' target='_blank'>
          <ServicesIcon src={icon3}/>
          </ServiceLink>
          <ServicesH2>tic tac toe</ServicesH2>
          <ServicesP>a game with a twist</ServicesP>
          <ServiceH4>VanillaStack JS CSS HTML</ServiceH4>
          <ServiceLink href='https://github.com/eladbarzilay/workinJS/tree/main/HTML2/ticTacToe' target='_blank'>
            <ServiceH1>
              <FaGithub/>
            </ServiceH1>
          </ServiceLink>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  )
}

export default Services